import React, { useContext, useEffect, useRef, useState } from 'react';
import { Sidebar, Menu, MenuItem, MenuItemStyles, menuClasses, SubMenu } from 'react-pro-sidebar';
import MenuTop from './MenuTop';
import LazyLoading from '../../../../components/LazyLoading';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../contexts/AppContext';
import { AuthContext } from '../../../../contexts/AuthContext';
import { getMenuItemStyles, hexToRgba, themes } from './Sidebar/utils/getTheme';
import {
    ITEMS,
    MENU_ITEMS,
    PERMISSIONS_APP,
    verify_permission
} from './Sidebar/utils/getPermissions';
import { Dashboard } from '../iconSVG/Dashboard';
import { Event } from '../iconSVG/Event';

type Theme = 'light' | 'dark';

const SidebarPro = () => {
    const location = useLocation();
    const { showingMainMenu, showMainMenu, hideMainMenu, changeMainMenu } = useContext(AppContext);
    const [collapsed, setCollapsed] = React.useState(false);
    const [menuItemStyles, setMenuItemStyles] = React.useState<MenuItemStyles>();
    const [broken, setBroken] = React.useState(false);
    const [rtl, setRtl] = React.useState(false);
    const [theme, setTheme] = React.useState<Theme>('dark');
    const { authCompany } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setMenuItemStyles(getMenuItemStyles(theme, collapsed));
    }, [theme, collapsed]);

    const onBackdropClick = () => {
        console.log('click atras para cerrar');
        if (hideMainMenu) hideMainMenu();
    };

    useEffect(() => {
        if (broken) {
            onBackdropClick();
            setCollapsed(false);
        } else {
            if (showMainMenu) showMainMenu();
        }
    }, [broken]);

    useEffect(() => {
        const body = document.body;
        // Toggle 'vertical-collpsed' based on the value of 'collapsed'
        body.classList.toggle('vertical-collpsed', collapsed);

        // Toggle 'sidebar-enable' based on the negation of 'collapsed'
        body.classList.toggle('sidebar-enable', !collapsed);
    }, [collapsed]);

    // handle on RTL change event
    const handleRTLChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRtl(e.target.checked);
    };

    // handle on theme change event
    const handleThemeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTheme(e.target.checked ? 'dark' : 'light');
    };

    // handle on image change event
    //   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setHasImage(e.target.checked);
    //   };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 500);
        console.log('collapsed');
    }, [collapsed]);

    useEffect(() => {
      console.log(location.pathname)
    }, [location]);

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    display: 'flex',
                    // height: '100vh',
                    top: 70,
                    bottom: 0,
                    zIndex: 1000
                }}
            >
                <MenuTop />
                <Sidebar
                    collapsed={collapsed}
                    toggled={showingMainMenu}
                    onBackdropClick={hideMainMenu}
                    onBreakPoint={setBroken}
                    image="https://user-images.githubusercontent.com/25878302/144499035-2911184c-76d3-4611-86e7-bc4e8ff84ff5.jpg"
                    rtl={rtl}
                    breakPoint="md"
                    backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, 1)}
                    rootStyles={{
                        color: themes[theme].sidebar.color
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: 1, marginBottom: '32px' }}>
                            {loading ? (
                                <LazyLoading height="300" />
                            ) : (
                                <>
                                    {!broken && (
                                        <div
                                            style={{
                                                padding: '0 18px',
                                                marginBottom: '0px',
                                                marginTop: '0px',
                                                textAlign: 'left'
                                            }}
                                        >
                                            <button
                                                type="button"
                                                style={{ height: '50px' }}
                                                onClick={() => {
                                                    setCollapsed(!collapsed);
                                                }}
                                                className="btn btn-sm font-size-16 header-item "
                                                id="vertical-menu-btn"
                                            >
                                                <i className="fa fa-fw fa-bars text-white" />
                                            </button>
                                        </div>
                                    )}
                                    <Menu menuItemStyles={menuItemStyles}>
                                        <MenuItem
                                            active={location.pathname === '/company/dashboard'}
                                            icon={<Dashboard />}
                                            component={<Link to={'/company/dashboard'} />}
                                        >
                                            Dashboard
                                        </MenuItem>
                                    </Menu>
                                    <Menu menuItemStyles={menuItemStyles}>
                                        <MenuItem
                                            active={location.pathname === '/company/events'}
                                            icon={<Event />}
                                            component={<Link to={'/company/events'} />}
                                        >
                                            Eventos
                                        </MenuItem>
                                    </Menu>
                                </>
                            )}
                        </div>
                    </div>
                </Sidebar>
            </div>
        </>
    );
};

export default SidebarPro;
